import React from 'react';
import {
    GenieMemoryConfig,
    GenieMemoryCustomItem,
    GeniePadElementsSettingItem,
} from '../../api/pushGenie';
import { GenieTableType, PAD_ELEMENTS_IDS } from '../../constants';
import { Checkbox, Collapse, Switch } from 'antd';

const { Panel } = Collapse;

interface GenieCustomSectionMemoryConfigProps {
    config: GenieMemoryCustomItem[];
    type: GenieTableType;
    updateConfig: React.Dispatch<React.SetStateAction<GenieMemoryConfig | undefined>>;
    padElements: GeniePadElementsSettingItem[];
}

const GenieCustomSectionMemoryConfig: React.FC<GenieCustomSectionMemoryConfigProps> = ({
    config,
    updateConfig,
    padElements,
}) => {
    const customSections = padElements.filter((item) => !PAD_ELEMENTS_IDS.includes(item.id));

    const handleToggleSection = (sectionId: string, current: boolean) => {
        updateConfig((prev) => {
            const exists = prev?.customSections?.some((item) => item.sectionId === sectionId);
            const newCustomSections = exists
                ? prev!.customSections!.map((item) =>
                      item.sectionId === sectionId ? { ...item, isSectionEnabled: !current } : item,
                  )
                : [
                      ...(prev?.customSections || []),
                      { sectionId, isSectionEnabled: !current, rememberNotes: true },
                  ];
            return { ...prev, customSections: newCustomSections };
        });
    };

    const handleToggleRememberNotes = (sectionId: string, current: boolean) => {
        updateConfig((prev) => {
            const exists = prev?.customSections?.some((item) => item.sectionId === sectionId);
            const newCustomSections = exists
                ? prev!.customSections!.map((item) =>
                      item.sectionId === sectionId ? { ...item, rememberNotes: !current } : item,
                  )
                : [
                      ...(prev?.customSections || []),
                      { sectionId, isSectionEnabled: true, rememberNotes: !current },
                  ];
            return { ...prev, customSections: newCustomSections };
        });
    };

    return (
        <div className="p-16 flex flex-col flex-1 h-full overflow-auto gap-16">
            {customSections.map((section) => {
                const sectionConfig = config.find((item) => item.sectionId === section.id);
                const isEnabled = sectionConfig?.isSectionEnabled ?? true;
                const rememberNotes = sectionConfig?.rememberNotes ?? true;

                return (
                    <Collapse
                        key={section.id}
                        activeKey={isEnabled ? ['1'] : []}
                        bordered={false}
                        className="rounded-8"
                    >
                        <Panel
                            key="1"
                            header={
                                <div className="flex flex-row rounded-8 w-full justify-between items-center pl-8 py-8 pb-0">
                                    <p className="text-darwin-neutral-1000 heading-3 bold">
                                        {section.name} (sub section)
                                    </p>
                                    <Switch
                                        checked={isEnabled}
                                        onClick={() => handleToggleSection(section.id, isEnabled)}
                                    />
                                </div>
                            }
                            showArrow={false}
                        >
                            <div className="flex flex-col">
                                <div className="flex flex-row items-center justify-between pr-14">
                                    <p className="ml-20">Remember notes</p>
                                    <Checkbox
                                        className="flex items-center justify-center cursor-pointer"
                                        checked={rememberNotes}
                                        onChange={() =>
                                            handleToggleRememberNotes(section.id, rememberNotes)
                                        }
                                    />
                                </div>
                            </div>
                        </Panel>
                    </Collapse>
                );
            })}
        </div>
    );
};

export default GenieCustomSectionMemoryConfig;
